import React from 'react'
import { SxProps } from '@mui/material'
// Components
import { SettingsItem } from '.'
import { nothing } from '$helper/functions/utils'

interface Props {
  text: string
  Icon: React.ComponentType<{ sx: SxProps }>
  onClick: () => any
  color?: string
}

export function SettingsItemWithIcon({
  text,
  Icon,
  onClick = nothing,
  color,
}: Props) {
  return (
    <SettingsItem
      text={text}
      secondaryContent={<Icon sx={{ color: color || '#55A6FF' }} />}
      onClick={onClick}
      color={color}
    />
  )
}
